const api = "https://vehicle-requisition-server.onrender.com/api";
//const api = "http://localhost:5000/api";
module.exports = api;
